import { CFAR_FULL_ON_COUNTRIES, CFAR_BE_EXPERIMENT_COUNTRIES, CFAR_TEST_MARKET_COUNTRIES } from "./constants.js";
import { t } from "@bookingcom/lingojs-core";
import { pricingUtils } from "@flights/web-api-utils-universal";
export function getCancelForAnyReasonMarket(pointOfSale) {
    const pos = pointOfSale.toLowerCase();
    if (CFAR_FULL_ON_COUNTRIES.includes(pos) || CFAR_BE_EXPERIMENT_COUNTRIES.includes(pos))
        return "target";
    return pointOfSale;
}
export const getCfarMaxRefundCopy = (i18n, pointOfSale, locale, refundInformation) => {
    const pos = String(pointOfSale).toLowerCase();
    const cfarMaxRefund = refundInformation ? refundInformation : getCfarMaxRefund(pos);
    return i18n.trans(t("flights_cfar_benefit_4b", {
        variables: {
            cfar_refund: pricingUtils.formatPrice(cfarMaxRefund, locale)
        }
    }));
};
export const getCfarMaxRefund = (pos) => {
    if (pos === "us")
        return { units: 2600, nanos: 0, currencyCode: "USD" };
    if (pos === "au")
        return { units: 4300, nanos: 0, currencyCode: "AUD" };
    if (pos === "ca")
        return { units: 4000, nanos: 0, currencyCode: "CAD" };
    if (pos === "gb")
        return { units: 2500, nanos: 0, currencyCode: "GBP" };
    if (pos === "se")
        return { units: 30_000, nanos: 0, currencyCode: "SEK" };
    if (pos === "dk")
        return { units: 20_000, nanos: 0, currencyCode: "DKK" };
    if (pos === "in")
        return { units: 210_000, nanos: 0, currencyCode: "INR" };
    if (pos === "th")
        return { units: 84_000, nanos: 0, currencyCode: "THB" };
    if (pos === "kw")
        return { units: 750, nanos: 0, currencyCode: "KWD" };
    if (pos === "mx")
        return { units: 46_000, nanos: 0, currencyCode: "MXN" };
    return { units: 2500, nanos: 0, currencyCode: "EUR" };
};
export function isAirportSearchLocation(location) {
    return location.type === "AIRPORT";
}
export function isSearchSegmentType(segment) {
    return segment.hasOwnProperty("from");
}
export function isCfarFullOnPos(pointOfSale) {
    const pos = (pointOfSale || "").toLowerCase();
    return CFAR_FULL_ON_COUNTRIES.includes(pos);
}
export function isEligiblePos(pointOfSale) {
    const pos = (pointOfSale || "").toLowerCase();
    return CFAR_FULL_ON_COUNTRIES.includes(pos) || CFAR_TEST_MARKET_COUNTRIES.includes(pos);
}
